import React, { useEffect, useState } from "react";

const UnattendedAccessTermsModal = ({ isOpen, terms, loading, accepting, error, onAccept, onClose }) => {
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        setChecked(false);
    }, [isOpen, terms?.version]);

    if (!isOpen) {
        return null;
    }

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-lg max-h-[80vh] flex flex-col">
                {loading || !terms ? (
                    <p className="text-gray-700">Wird geladen...</p>
                ) : (
                    <>
                        <h2 className="text-lg font-bold text-gray-800 mb-4">{terms.title}</h2>
                        <div
                            className="text-gray-700 text-sm overflow-y-auto mb-4"
                            dangerouslySetInnerHTML={{ __html: terms.text }}
                        ></div>

                        {error && (
                            <p className="text-red-500 text-sm mb-4">{error}</p>
                        )}

                        <label className="flex items-start text-sm mb-4 cursor-pointer">
                            <input
                                type="checkbox"
                                className="mr-2 mt-1"
                                checked={checked}
                                onChange={() => setChecked((prev) => !prev)}
                            />
                            <span>Ich habe die Bedingungen gelesen und akzeptiere sie.</span>
                        </label>

                        <div className="flex justify-end gap-2">
                            <button
                                onClick={onClose}
                                disabled={accepting}
                                className="text-pegasusPurple underline px-2"
                            >
                                Abbrechen
                            </button>
                            <button
                                onClick={onAccept}
                                disabled={!checked || accepting}
                                className={`py-2 px-4 rounded-lg font-semibold ${
                                    checked && !accepting
                                        ? "bg-pegasusPurple text-white hover:bg-pegasusPurpleHover"
                                        : "bg-gray-300 text-gray-600 cursor-not-allowed"
                                }`}
                            >
                                {accepting ? "Wird bestätigt..." : "Akzeptieren und fortfahren"}
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default UnattendedAccessTermsModal;
